document.addEventListener("DOMContentLoaded", function () {
    const select = document.querySelector("#tag_filter");
  
    function updateDropdownFromURL() {
        let currentPath = window.location.pathname; 
        
        // Loop through options and set the selected one
        for (let option of select.options) {
            if (option.value === currentPath) {
                option.selected = true;
                break;
            }
        }
    }

setTimeout(() => {
  updateDropdownFromURL()
}, 100);
    
    select.addEventListener("change", function () {
        let selectedValue = select.value; 
        let currentURL = new URL(window.location.href);
        let baseURL = window.location.origin; 

        // Preserve 'sort_by' and other query parameters
        let searchParams = currentURL.searchParams.toString();
        let hash = currentURL.hash; // Preserve any existing hash

        // Construct new URL
        let newURL = `${baseURL}${selectedValue}`;
        if (searchParams) {
            newURL += `?${searchParams}`;
        }
        if (hash) {
            newURL += hash;
        }

        // Change the page URL
        window.location.href = newURL;
    });
});
